import { HttpParams } from '@angular/common/http';

import { HttpQueryParams } from '@/app/core/services/http';

import { formatFilterValue } from '@/app/shared/utils/format-filter-value';

export type ParamArrayFormat = 'comma' | 'brackets' | 'repeat';
export type BooleanFormat = 'trueFalse' | 'zeroOne';
export type DateFormat = 'iso' | ((date: Date) => string);

export interface BuildParamsOptions {
  arrayFormat?: ParamArrayFormat;
  booleanFormat?: BooleanFormat;
  dateFormat?: DateFormat;
}

export function buildParamsStrict(obj: HttpQueryParams, options: BuildParamsOptions = {}): HttpParams {
  let params = new HttpParams();

  const { arrayFormat = 'comma' } = options;

  Object.entries(obj).forEach(([key, rawValue]) => {
    if (
      rawValue === null ||
      rawValue === undefined ||
      rawValue === '' ||
      (Array.isArray(rawValue) && rawValue.length === 0)
    ) {
      return;
    }

    if (Array.isArray(rawValue)) {
      const values = rawValue.map((value) => formatFilterValue(value, options));

      switch (arrayFormat) {
        case 'brackets':
          values.forEach((v) => {
            params = params.append(`${key}[]`, v);
          });
          break;
        case 'repeat':
          values.forEach((v) => {
            params = params.append(key, v);
          });
          break;
        case 'comma':
        default:
          params = params.set(key, values.join(','));
      }
    } else {
      const value = formatFilterValue(rawValue, options);
      params = params.set(key, value);
    }
  });

  return params;
}
